<div>
    <!-- Upload Area -->
    <div class="b-a bg-col-w b-radius-4 cursor-pointer"
         [ngClass]="isDragOver ? 'b-col-11' : 'b-col-4'"
         (dragover)="onDragOver($event)"
         (dragleave)="onDragLeave($event)"
         (drop)="onDrop($event)">

        <input type="file"
               [name]="name"
               [required]="required && !file"
               [accept]="accept"
               (change)="onFileSelect($event)"
               class="_file-input pos-absolute"
               #fileInput>

        <div class="pe-none flex flex-middle p-a-8">
            <button type="button"
                    class="button m-r _select-file-btn"
                    (click)="fileInput.click()">
                <span>{{ (openBrowserText || 'Select file') | translate }}</span>
                <i class="icon-file inline-flex"
                   aria-hidden="true"></i>
            </button>
            <p class="_upload-text">{{ (dragDropText || '| or drag and drop file here') | translate }}</p>
        </div>
    </div>

    <!-- Error Messages -->
    @if (errors.length > 0) {
    @for (error of errors; track $index) {
    <div class="p2 col-2 m-t-1">
        <span>{{ error | translate }}</span>
    </div>
    }
    }

    <!-- Selected File Display -->
    @if (file) {
    <div class="m-t">
        <h4 class="p2">{{ 'Selected file' | translate }}</h4>
        <div class="m-t-1 flex flex-middle flex-justify-between p-a-2 bg-col-51 b-a b-radius-4 b-col-4">
            <div class="flex flex-middle">
                <i class="icon-file m-r-2"
                   aria-hidden="true"></i>
                <div class="flex-column">
                    <span class="p2">{{file.name}}</span>
                    <span class="p3 col-4 m-t-1">{{formatFileSize(file.size)}}</span>
                </div>
            </div>
            <button type="button"
                    class="col-2"
                    (click)="removeFile()"
                    [attr.aria-label]="'Remove file' | translate">
                <i class="icon-close p1"
                   aria-hidden="true"></i>
            </button>
        </div>
    </div>
    }
</div>
